module.exports = __webpack_public_path__ + "media/assets/images/arrows/enyaOrange-80b3018d1ca6b6e6d36417aeb76475b4.svg";